// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CouponsEnityMappers from "../entity-mapper/CouponsEnityMappers.bs.js";
import * as PlcaOrderEnityMapper from "../entity-mapper/PlcaOrderEnityMapper.bs.js";
import * as PlaceOrderErrorConverter from "../error-converter/PlaceOrderErrorConverter.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as LocationBoundEntityMapper from "../entity-mapper/LocationBoundEntityMapper.bs.js";
import * as VehicleDetailsEntityMapper from "../entity-mapper/VehicleDetailsEntityMapper.bs.js";
import * as RestrictionBoundEntityMapper from "../entity-mapper/RestrictionBoundEntityMapper.bs.js";
import * as VehicleQuotationsEntityMapper from "../entity-mapper/VehicleQuotationsEntityMapper.bs.js";

var execute = LocationBoundEntityMapper.execute;

var LocationBoundsResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var LocationBoundsResponseConverter = partial_arg(LocationBoundsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = RestrictionBoundEntityMapper.execute;

var RestrictionBoundsResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var RestrictionBoundsResponseConverter = partial_arg$1(RestrictionBoundsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = VehicleDetailsEntityMapper.execute;

var VehicleDetailsResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var VehicleDetailsResponseConverter = partial_arg$2(VehicleDetailsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = VehicleQuotationsEntityMapper.execute;

var VehicleQuotationsResponseConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var VehicleQuotationsResponseConverter = partial_arg$3(VehicleQuotationsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$4 = CouponsEnityMappers.execute;

var CouponListResponseConverterConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var CouponListResponseConverter = partial_arg$4(CouponListResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$5 = PlcaOrderEnityMapper.execute;

var PlaceOrderResponseConverterConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var PlaceOrderResponseConverter = partial_arg$5(PlaceOrderResponseConverterConfig, {
      execute: PlaceOrderErrorConverter.execute
    });

export {
  LocationBoundsResponseConverterConfig ,
  LocationBoundsResponseConverter ,
  RestrictionBoundsResponseConverterConfig ,
  RestrictionBoundsResponseConverter ,
  VehicleDetailsResponseConverterConfig ,
  VehicleDetailsResponseConverter ,
  VehicleQuotationsResponseConverterConfig ,
  VehicleQuotationsResponseConverter ,
  CouponListResponseConverterConfig ,
  CouponListResponseConverter ,
  PlaceOrderResponseConverterConfig ,
  PlaceOrderResponseConverter ,
  
}
/* LocationBoundsResponseConverter Not a pure module */
